export const CLASS_NAME = 'cst-insights-select-years'
export const WIDTH = 650
export const ALL_LCC_OPTION = {
  label: 'All Land Cover Classes',
  value: 'all'
}
